import { Injectable } from '@angular/core';
import { decryptData, encryptData } from "../encryptData/encrypt-data.service";
import swal from 'sweetalert2';
import { Subject, throwError } from "rxjs";
import { Router } from "@angular/router";
import { CommonConstants } from "../constants/common-constants";
import * as CryptoJS from 'crypto-js';
import { AbstractControl, UntypedFormControl, ValidatorFn } from '@angular/forms';
import { PermissionListService } from './permission-list.service';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from "pdfmake/build/vfs_fonts";
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class HelperService {
  private readonly datePipe = new DatePipe('en-US');
  pageName = new Subject<any>();
  grnPageName = new Subject<any>();
  adjustmentClose = new Subject<any>();
  grnBackBtn = new Subject<any>();
  backBtn = new Subject<any>();
  notificationSub = new Subject<any>();
  isInCall = new Subject<any>();
  rejectCall = new Subject<any>();
  currentUser: any;
  constructor(
    private _router: Router,
    private _permissionService: PermissionListService
  ) { }

  /**
   * Summary: This method is used to set value in localstorage.
   * @param keyName :  input is the name of key
   * @param keyValue :  input is value of key
   * @returns
   */
  public setLocalStorageData(keyName: any, keyValue: any) {
    localStorage.setItem(keyName, <string>encryptData(keyValue));
    return true
  }

  /**
   * Summary: This method is used to get value from localstorage.
   * @param keyName :  input is the name of key
   * @returns
   */
  public getLocalStorageData(keyName: any) {
    var localStorageDetails = localStorage.getItem(keyName);
    if (localStorageDetails != null && localStorageDetails != '') {
      return decryptData(localStorageDetails)
    } else {
      return false
    }
  }

  /*public encryptLocalStorageData(value: any) {
    if (value != null && value !== '') {
      const dataToEncrypt = typeof value === 'string' ? value : JSON.stringify(value);
      const encryptedValue: any = encryptData(dataToEncrypt);
      return encryptedValue;
    } else {
      return false;
    }
  }*/

  public encryptLocalStorageData(value: any) {
    if (value != null && value !== '') {
      const dataToEncrypt = typeof value === 'string' ? value : JSON.stringify(value);
      let encryptedValue: any = encryptData(dataToEncrypt);

      // Make it URL/file safe by replacing special characters
      encryptedValue = encryptedValue
        .replace(/\+/g, '-')   // replace + with -
        .replace(/\//g, '_')   // replace / with _
        .replace(/=+$/, '');   // remove = padding

      return encryptedValue;
    } else {
      return false;
    }
  }

  public decryptLocalStorageData(encryptedValue: string) {
    if (!encryptedValue) return false;

    // Restore original Base64
    let base64 = encryptedValue
      .replace(/-/g, '+')
      .replace(/_/g, '/');

    // Add padding back if needed
    while (base64.length % 4) {
      base64 += '=';
    }

    return decryptData(base64);
  }

  /*decryptResponse(response :any ) {
    try {
      return CryptoJS.AES.encrypt(JSON.stringify(response), CommonConstants.encryptSecretKey).toString();
    } catch (error: any) {
      console.error('Decryption failed', error);
      return null;
    }
  }*/

  decryptResponse(cipherText: string): any {
    try {
      const bytes = CryptoJS.AES.decrypt(cipherText, CommonConstants.encryptSecretKey);
      const decryptedText = bytes.toString(CryptoJS.enc.Utf8);

      if (!decryptedText) {
        throw new Error('Decryption returned empty string. Possibly wrong key or corrupted input.');
      }

      return JSON.parse(decryptedText);
    } catch (error: any) {
      console.error('Decryption failed:', error.message || error);
      return null;
    }
  }

  /**
   * Summary: This method is used to remove value from localstorage.
   * @param keyName : input is the name of key
   * @returns
   */
  public removeLocalStorageData(keyName: any) {
    localStorage.removeItem(keyName);
  }


  clearLocalStorageData() {
    this.removeLocalStorageData(CommonConstants.USER_DATA)
    this.removeLocalStorageData(CommonConstants.TOKEN)
    this.removeLocalStorageData(CommonConstants.IS_ADMIN)
    this.removeLocalStorageData(CommonConstants.FORGOT_EMAIL)
    this.removeLocalStorageData(CommonConstants.DEVICE_TOKEN)
    this.removeLocalStorageData(CommonConstants.DEFAULT_ROUTE)
  }

  //Session storage functions
  setSessionData(key: string, data: any): void {
    try {
      const encryptedData = CryptoJS.AES.encrypt(
        JSON.stringify(data),
        CommonConstants.encryptSecretKey
      ).toString();
      sessionStorage.setItem(key, encryptedData);
    } catch (error) {
      console.error('Session encryption failed', error);
    }
  }

  getSessionData(key: string): any {
    try {
      const encryptedData = sessionStorage.getItem(key);
      if (!encryptedData) {
        return null;
      }
      const bytes = CryptoJS.AES.decrypt(encryptedData, CommonConstants.encryptSecretKey);
      return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    } catch (error) {
      console.error('Session decryption failed', error);
      return null;
    }
  }

  /**
   * Toast message
   * @param message
   * @param icon
   */
  toast(message: any, icon: any) {
    let Toast = swal.mixin({
      toast: true,
      position: 'bottom-right',
      // iconColor: 'white',
      customClass: {
        popup: 'colored-toast'
      },
      showConfirmButton: false,
      timer: 4000,
      timerProgressBar: false
    })
    return Toast.fire({
      icon: icon,
      title: message
    })
  }
  removedFilters() {
    this.removeLocalStorageData(CommonConstants.IS_BACK);
    this.removeLocalStorageData(CommonConstants.PAGE_NAME);
    this.removeLocalStorageData(CommonConstants.PER_PAGE);
    this.removeLocalStorageData(CommonConstants.CURRENT_PAGE);
    this.removeLocalStorageData(CommonConstants.USER_STATUS);
    this.removeLocalStorageData(CommonConstants.IS_SEARCH);
    this.removeLocalStorageData(CommonConstants.USER_STATUS);
    this.removeLocalStorageData(CommonConstants.FORGOT_EMAIL);
    this.removeLocalStorageData(CommonConstants.QUERY);
  }

  /**
   * This method is use for get permission list for all module
   * @param route 
   * @returns 
   */
  //   getPermissions(route: any) {
  //     let currentPermission: any
  //     let permissionList = this._permissionService?.getPermissionList();
  //     if(permissionList){
  //       currentPermission = permissionList?.find(
  //         (p: any) => p.value === route
  //       );
  //     }

  //     return currentPermission
  // }
  getPermissions(route: string): any {
    const permissionList = this._permissionService?.getPermissionList();
    if (!permissionList) return null;

    // Recursive search
    const findPermission = (permissions: any[], route: string): any => {
      for (const perm of permissions) {
        if (perm.value === route) {
          return perm;
        }

        if (perm.childPermissions && perm.childPermissions.length) {
          const found = findPermission(perm.childPermissions, route);
          if (found) return found;
        }
      }
      return null;
    };

    return findPermission(permissionList, route);
  }


  /**
   * Summary: This method is use for handle error
   * @param err
   * @private
   */
  public handleAuthError(err: any, showErrorToast: boolean = true): any {
    const errorMessage = err?.error?.message || err?.message || "Error";

    if (err.status === 0 || err?.error?.statusCode === 0) {
      if (showErrorToast) {
        this.toast(err?.meta?.message || "Error", "error");
      }
    }
    if (err.status === 400 || err?.error?.statusCode === 400) {
      if (showErrorToast) {
        this.toast(errorMessage, "error");
      }
    }
    if (err.status === 404 || err?.error?.statusCode === 404) {
      if (showErrorToast) {
        this.toast(errorMessage, "error");
      }
    }
    if (err.status === 401 || err?.error?.statusCode === 401) {
      if (showErrorToast) {
        this.toast(errorMessage, "error");
      }
      this.getUnauthorizedUser();
    }
    if (err.status === 500 || err?.error?.statusCode === 500) {
      if (showErrorToast) {
        this.toast(errorMessage, "error");
      }
    }
    return throwError(err);
  }

  getUnauthorizedUser() {
    this._router.navigateByUrl('/login');
    this.removeLocalStorageData(CommonConstants.TOKEN);
    this.removeLocalStorageData(CommonConstants.IS_ADMIN);
  }

  /**
     * Summary: It is use for handle error of image
     * @param e
     * @param type
     */
  setErrorImage(e: any, type?: any) {
    if (type == 'user') {
      e.target.src = 'images/profile.png';
    } else {
      e.target.src = 'images/placeHolderImage.jpg';
    }
  }

  public checkLogin(keyName: any) {
    return !!localStorage.getItem(keyName)
  }

  allowOnlyNumbers(event: any) {
    const charCode = event.charCode;
    if (charCode !== 0 && charCode !== 8 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
    }
  }

  // In your component.ts
  allowOnlyNumbersAndDot(event: KeyboardEvent, allowNegative: boolean = false) {
    const input = event.target as HTMLInputElement;
    const char = event.key;

    const controlKeys = [
      'Backspace',
      'Delete',
      'ArrowLeft',
      'ArrowRight',
      'ArrowUp',
      'ArrowDown',
      'Home',
      'End',
      'Tab',
      'Escape',
      'Enter',
    ];

    // Allow control keys
    if (controlKeys.includes(char)) {
      return;
    }

    // Allow numbers 0-9
    if (/^[0-9]$/.test(char)) {
      return;
    }

    // Allow single dot (not as first character)
    if (char === '.' && !input.value.includes('.') && input.value.length > 0) {
      return;
    }

    // Allow negative sign if enabled
    if (
      allowNegative &&
      char === '-' &&
      input.selectionStart === 0
    ) {
      return;
    }

    // Block everything else
    event.preventDefault();
  }


  validate0To100(event: any) {
    const input = event.target as HTMLInputElement;
    const pos = input.selectionStart!;
    let v = input.value;

    if (v !== "0" && v.startsWith("0") && !v.startsWith("0.")) {
      v = v.replace(/^0+/, "");
    }

    if (v === "") v = "0";

    if (v.endsWith(".")) {
      input.value = v;
      input.setSelectionRange(pos, pos);
      return;
    }

    const num = parseFloat(v);

    if (isNaN(num) || num < 0 || num > 100) v = "0";

    input.value = v;
    input.setSelectionRange(pos, pos);
  }



  allowTextOnly(event: any) {
    let input = event.target;
    let value = input.value;

    // Remove numbers and special characters (allow only letters and spaces)
    value = value.replace(/[^a-zA-Z ]/g, '');

    // Remove leading space
    value = value.replace(/^\s+/g, '');

    // Replace multiple spaces with a single space
    value = value.replace(/\s{2,}/g, ' ');

    input.value = value;
  }

  exportSerialNumbersToExcel(serialNumbers: (string | number)[], fileName = 'serial_numbers.xlsx'): void {
    if (!serialNumbers || serialNumbers.length === 0) {
      console.error('No data to export');
      return;
    }

    // Convert array to Excel-friendly format
    const worksheetData = serialNumbers.map(value => ({
      serialNumber: value
    }));

    // Create worksheet
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(worksheetData);

    // Create workbook
    const workbook: XLSX.WorkBook = {
      Sheets: { Sheet1: worksheet },
      SheetNames: ['Sheet1']
    };

    // Export file
    XLSX.writeFile(workbook, fileName);
  }

  maxQuantityValidator = (max: number): ValidatorFn => {
    return (control: AbstractControl) => {
      const value = control.value;
      if (value != null && value > max) {
        return { maxQuantityExceeded: true };
      }
      return null;
    };
  };

  generateXlsx(exportData: any, name: string) {
    this.currentUser = this.getLocalStorageData('_UR');

    if (exportData?.length > 0) {
      // Filter out the keys dynamically
      const cleanedData = exportData.map((item: any) => {
        const newItem = { ...item };
        if (this.currentUser == 'warehouseManager' && name == 'Purchase Order') {
          ['Price', 'Currency'].forEach(key => delete newItem[key]);
        }
        ['Created At', 'Updated At'].forEach(key => {
          if (newItem[key]) {
            newItem[key] = this.datePipe.transform(
              newItem[key],
              'dd MMM, yyyy hh:mm a'
            );
          }
        });
        return newItem;
      });

      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(cleanedData);
      const workbook: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      const excelBuffer: any = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, name);
    } else {
      this.toast(`There is no ${name} data`, 'error');
    }
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: "application/octet-stream" });
    saveAs(data, `${fileName}.xlsx`);
  }

  replaceSpaceWithUnderscore(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    const cursorPos = input.selectionStart ?? 0;
    const prevChar = value[cursorPos - 1];
    const nextChar = value[cursorPos];

    // Block ALL special chars except underscore
    const allowedPattern = /^[a-zA-Z0-9_]$/;

    // Handle space → underscore
    if (event.key === ' ') {
      event.preventDefault();
      if (prevChar === '_' || nextChar === '_') return;

      const start = cursorPos;
      const end = input.selectionEnd ?? cursorPos;

      input.value = value.slice(0, start) + '_' + value.slice(end);
      input.setSelectionRange(start + 1, start + 1);
      return;
    }

    // If key is NOT a letter, number, or underscore → block it
    if (!allowedPattern.test(event.key)) {
      event.preventDefault();
      return;
    }

    // Prevent consecutive underscores
    if (event.key === '_' && (prevChar === '_' || nextChar === '_')) {
      event.preventDefault();
      return;
    }
  }




  generatePdf(data: any[], name: string) {
    if (!data || data.length === 0) {
      this.toast(`There is no ${name} data`, 'error')
      return;
    }
    this.currentUser = this.getLocalStorageData('_UR');

    // Filter out the keys dynamically
    const cleanedData = data.map((item: any) => {
      const newItem = { ...item };
      if (this.currentUser == 'warehouseManager' && name == 'Purchase Order') {
        ['Price', 'Currency'].forEach(key => delete newItem[key]);
      }
      ['Created At', 'Updated At'].forEach(key => {
        if (newItem[key]) {
          newItem[key] = this.datePipe.transform(
            newItem[key],
            'dd MMM, yyyy hh:mm a'
          );
        }
      });
      return newItem;
    });
    const headers = Object.keys(cleanedData[0]);
    const tableBody: any[] = [];
    tableBody.push(headers.map((h) => ({ text: h, style: "tableHeader" })));
    cleanedData.forEach((item) => {
      const row = headers.map((h: any) => {
        let val = item[h];

        if (val === null || val === undefined || val === "") return "-";
        const valStr = String(val);
        if (valStr.includes("T") && !isNaN(Date.parse(valStr))) {
          return new Date(valStr).toLocaleString(); // format to local time
        }

        return val;
      });

      tableBody.push(row);
    });
    // 🔹 Define PDF structure
    setTimeout(() => {
      const docDefinition: any = {
        pageOrientation: "landscape",
        pageSize: "A3",
        content: [
          {
            text: `${name} Report`,
            style: "header",
            margin: [0, 0, 0, 10],
          },
          {
            table: {
              headerRows: 1,
              widths: Array(headers.length).fill("*"),
              body: tableBody,
            },
            layout: "lightHorizontalLines",
          },
        ],
        styles: {
          header: { fontSize: 18, bold: true, alignment: "center" },
          tableHeader: {
            bold: true,
            fillColor: "#eeeeee",
          },
        },
        defaultStyle: { fontSize: 9 },
      };

      (pdfMake as any)
        .createPdf(docDefinition, (pdfFonts as any).pdfMake?.vfs)
        .download(`${name}.pdf`);
    }, 1000);
  }

  /**
   * Prevents the default action for Enter key presses to restrict accidental button clicks.
   * @param event The keyboard event.
   */
  preventEnter(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();
    }
  }

}


export class noWhitespaceValidation {
  static noWhitespaceValidator(control: UntypedFormControl): any {
    const isWhitespace = (control && control.value && control.value.toString() || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { required: true };
  }


}

export class requiredNonZero {
  static requiredNonZeroValidator(control: any): any {
    const value = control?.value;

    // invalid if: null, undefined, empty, only whitespace, OR 0
    const isInvalid =
      value === null ||
      value === undefined ||
      value <= 0 ||
      value.toString().trim().length === 0;

    return isInvalid ? { required: true } : null;
  }
}
